import ROUTES from '@lib/constants/routes';

/**
 * Нормализует pathname для сравнения (без завершающего слэша, кроме корня).
 */
export function normalizePathname(pathname) {
  return pathname?.replace(/\/+$/, '') || '/';
}

export function shouldSkipScrollToTop(pathname, prevPathname) {
  const currentPathNormalized = normalizePathname(pathname);
  const previousPathNormalized = normalizePathname(prevPathname);

  if (currentPathNormalized === ROUTES.news.root && previousPathNormalized.startsWith(`${ROUTES.news.root}/`)) {
    return true;
  }
  return currentPathNormalized.startsWith(`${ROUTES.news.root}/`);
}

export function getScrollToTopDecision(pathname, prevPathname) {
  const prev = prevPathname ?? null;
  const isFirstRunAfterLoad = prev == null;

  const currentPathNormalized = normalizePathname(pathname);
  const newsRoot = normalizePathname(ROUTES.news.root);
  const previousPathNormalized = normalizePathname(prev);

  const cameFromNewsDetails = previousPathNormalized.startsWith(`${newsRoot}/`);
  const forceShowHeaderOnEnterNews =
    currentPathNormalized === newsRoot &&
    !isFirstRunAfterLoad &&
    !cameFromNewsDetails &&
    previousPathNormalized !== newsRoot;

  const skipScrollToTop = shouldSkipScrollToTop(pathname, prev);
  const forceTopOnLoad = isFirstRunAfterLoad && currentPathNormalized === newsRoot;

  return {
    skipScrollToTop,
    forceTopOnLoad,
    forceShowHeaderOnEnterNews,
  };
}
